import {useReducedMotion, motion} from 'framer-motion';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import {invoicesVariants} from '../../../../utilities/framerVariants';
import styles from './List.module.scss';
import Status from "../../../elements/Status/Status";
import Spinner from "../../../elements/Spinner/Spinner";
import {useDispatch, useSelector} from "react-redux";
import Button from "../../../elements/Button/Button";
import {toggleModal} from "../../../../store/actions/modalActions";

const List = () => {
    const dispatch = useDispatch();
    const {loading, users} = useSelector((state) => state.user);
    const isEmpty = users.length === 0;
    const shouldReduceMotion = useReducedMotion();

    const variant = (element, index) => {
        return shouldReduceMotion
            ? invoicesVariants.reduced
            : invoicesVariants[element](index);
    };

    const showStatus = (isDisabled) => {
        if (isDisabled) {
            return <Status currStatus={'disabled'}/>
        } else {
            return <Status currStatus={'active'}/>
        }
    }

    const handleChangeStatus = (id) => {
        const user = users.find(user => user.id === id);
        dispatch(toggleModal('statusUser', user));
    }

    const handleDeleteUser = async (id) => {
        const user = users.find(user => user.id === id);
        dispatch(toggleModal('deleteUser', user));
    }

    if (loading) {
        return <Spinner/>
    }

    return (
        <>
            {isEmpty && <ErrorMessage/>}
            {!isEmpty && (
                <ul className={styles.list}>
                    {users.map(
                        ({id, email, isDisabled}, index) => (
                            <motion.li
                                className={styles.item}
                                key={id}
                                layout
                                variants={variant('list', index)}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                            >
                                <div className={styles.link}>
                                    <p className={styles.id}>
                                        <span className={styles.hashtag}># </span>
                                        {id}
                                    </p>
                                    <p className={styles.email}>
                                        {email}
                                    </p>
                                    {showStatus(isDisabled)}
                                    {!isDisabled ? (
                                        <Button className='secondary' onClick={() => handleChangeStatus(id)}>
                                            Disable
                                        </Button>
                                    ) : (
                                        <Button className='primary' onClick={() => handleChangeStatus(id)}>
                                            Enable
                                        </Button>
                                    )}
                                    <Button className='delete' onClick={() => handleDeleteUser(id)}>
                                        Delete
                                    </Button>
                                </div>
                            </motion.li>
                        )
                    )}
                </ul>
            )}
        </>
    );
};

export default List;
